import styled, { css } from 'styled-components';

const Text = styled.span`
  font-size: 12px;
  line-height: 16px;
  font-family: ${({ theme }) => theme.fonts.primaryFont};
  color: ${({ theme }) => theme.colors.textSecondary};

  ${props =>
    props.showError &&
    props.notAvailable &&
    css`
      text-decoration: line-through;
    `}

  ${props =>
    props.showError &&
    props.error &&
    css`
      color: ${props.theme.colors.error} !important;
    `}
`;

export default Text;
